import type { Vec2 } from "./aimAngle.js";

/**
 * 조준선 채움 연출(fade-in) 진행도 — 타겟 변경 시 0에서 시작해 durationMs 동안 1로 증가.
 * 조준선 길이를 이 값으로 스케일하면 발사대(아래)에서 타겟(위)으로 점진적으로 채워진다.
 * 0 미만/1 초과는 [0,1]로 클램프. durationMs<=0이면 즉시 1(연출 비활성).
 */
export function aimFadeProgress(elapsedMs: number, durationMs: number): number {
  if (durationMs <= 0) return 1;
  const p = elapsedMs / durationMs;
  return p < 0 ? 0 : p > 1 ? 1 : p;
}

/**
 * 조준 타겟이 바뀌었는지 — 좌표가 다르거나 null↔타겟 전환이면 변경으로 본다.
 * 벽돌은 파괴 전까지 고정 좌표라 좌표 비교로 식별 충분. 변경 시 fade를 리셋한다.
 */
export function aimTargetChanged(prev: Vec2 | null, curr: Vec2 | null): boolean {
  if (prev === null && curr === null) return false;
  if (prev === null || curr === null) return true;
  return prev.x !== curr.x || prev.y !== curr.y;
}
